import { InventoryImportRepository } from '@lib/api/repository/inventory-import/inventory-import.repository';
import { DurableInventoryBatchInput, InventoryImportRow } from '@lib/types';

export default class InventoryImportService {
  constructor(private repository: InventoryImportRepository) {}

  saveImportBatch(input: DurableInventoryBatchInput) {
    return this.repository.saveImportBatch(input);
  }

  listImportBatches(operationId: string, signal?: AbortSignal) {
    return this.repository.listImportBatches(operationId, signal);
  }

  matchImport(gameCode: string, rows: InventoryImportRow[]) {
    return this.repository.matchImport(gameCode, rows);
  }
}
